import moment from "moment";
import swal from "sweetalert";

import commoncss from "../../../myfin_v2/css/common.module.css";
import buttoncss from "../../../myfin_v2/css/button.module.css";
import Modal from "../../../myfin_v2/elements/Modal";
import { Button } from "../../../myfin_v2/elements/Button";
import Dropdown from "../../../myfin_v2/elements/Dropdown";
import InputGroup from "../../../myfin_v2/elements/InputGroup";
import { ReactComponent as CloseIcon } from "../../../myfin_v2/assets/icons/close.svg";
import standaloneCss from "../../../myfin_v2/css/standalone.module.css";
import { useState, useEffect } from "react";
import { translateFSApiHandler } from "../ApiServices/apiHandler";
import {ReactComponent as CalendarIcon} from "../../../myfin_v2/assets/icons/Calendar.svg";

const TranslateFSModal = ({ allProject, setShowTranslateFSModal }) => {

  const user = JSON.parse(localStorage.getItem("user"));
  const permissions = JSON.parse(localStorage.getItem("permission"));

  const functionalCurrencyList = [" ","INR", "USD", "LKR", "AUD"];
  const [allProjects, setAllProjects] = useState([]);
  const [projectId, setProjectId] = useState("");
  const [company, setCompany] = useState("");
  const [functionalCurrency, setFunctionalCurrency] = useState("");
  const [reportingCurrency, setReportingCurrency] = useState({
    label: " ",
    value: " ",
  });
  const [currentFinancialYear, setCurrentFinancialYear] = useState("");
  const [previousFinancialYear, setPreviousFinancialYear] = useState("");
  const [cyOpeningRate, setCYOpeningRate] = useState("");
  const [cyClosingRate, setCYClosingRate] = useState("");
  const [cyAverageRate, setCYAverageRate] = useState("");
  const [pyOpeningRate, setPYOpeningRate] = useState("");
  const [pyClosingRate, setPYClosingRate] = useState("");
  const [pyAverageRate, setPYAverageRate] = useState("");

  useEffect(() => {
    const projectList = allProject.map((item) => ({
      label: item.project_name,
      value: item._id,
    }));
    setAllProjects(projectList);
  }, [allProject]);

  useEffect(() => {
    if (projectId) {
      const project = allProject.find((project) => project._id === projectId);

      const rateData = project?.translateFS;

      setCompany(project?.companyData);
      setFunctionalCurrency(project?.currency);
      setCurrentFinancialYear(
        project?.current_year
          ? moment(project?.current_year).format("DD-MMM-YYYY")
          : ""
      );
      setPreviousFinancialYear(
        project?.previous_year
          ? moment(project?.previous_year).format("DD-MMM-YYYY")
          : ""
      );

      if (project?.reportingCurrency) {
        const currency = project.reportingCurrency;

        setReportingCurrency({
          label: currency,
          value: currency,
        });
      } else {
        setReportingCurrency({ label: " ", value: " " });
      }

      if (rateData) {
        setCYOpeningRate(rateData?.currentYearOpeningRate);
        setCYClosingRate(rateData?.currentYearClosingRate);
        setCYAverageRate(rateData?.currentYearAverageRate);
        setPYOpeningRate(rateData?.previousYearOpeningRate);
        setPYClosingRate(rateData?.previousYearClosingRate);
        setPYAverageRate(rateData?.previousYearAverageRate);
      } else {
        setCYOpeningRate("");
        setCYClosingRate("");
        setCYAverageRate("");
        setPYOpeningRate("");
        setPYClosingRate("");
        setPYAverageRate("");
      }
    }
  }, [projectId]);

  const handleSaveAndTranslate = () => {
    const payload = {
      reportingCurrency: reportingCurrency.value,
      translateFS: {
        currentYearOpeningRate: cyOpeningRate,
        currentYearClosingRate: cyClosingRate,
        currentYearAverageRate: cyAverageRate,
        previousYearOpeningRate: pyOpeningRate,
        previousYearClosingRate: pyClosingRate,
        previousYearAverageRate: pyAverageRate,
      },
    };

    translateFSApiHandler({ projectID: projectId }, payload)
      .then((response) => {
        if (response?.data?.success === true) {
          swal("Success", "Data saved successfully.", "success");
          setShowTranslateFSModal(false);
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to Save and Translate FS",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to Save and Translate FS",
          "error"
        );
      });
  };

  return (
    <>
      <Modal
        title={"Preset Information"}
        width="50%"
        headerActions={
          <CloseIcon
            onClick={() => {
              setShowTranslateFSModal(false);
            }}
            className="clickable"
          />
        }
        footerActions={
          <>
            <Button
              btnColor={buttoncss.secondary}
              onClick={() => {
                setShowTranslateFSModal(false);
              }}
              label="Cancel"
            />
            <Button
              btnColor={buttoncss.primary}
              label="Save and Translate"
              onClick={() => {
                handleSaveAndTranslate();
              }}
            />
          </>
        }
        onClose={() => console.log("Modal Closed")}
      >
        <div style={{"padding": "0 10px", "width": "100%" , "place-self": "center" }}>
          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Select Financials"
                  inputs={[
                    <>
                      <Dropdown
                        options={allProjects}
                        onSelect={(sel) => {
                          setProjectId(sel.value);
                        }}
                        placeHolder="Select Financials"
                        selected={{ label: "", value: "" }}
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Reporting Currency"
                  inputs={[
                    <>
                      <Dropdown
                        options={functionalCurrencyList.map((item, idx) => ({
                          label: item,
                          value: item,
                        }))}
                        onSelect={(sel) => setReportingCurrency(sel)}
                        placeHolder="Select Reporting Currency"
                        selected={reportingCurrency}
                      />
                    </>,
                  ]}
                />
              </>,
            ]}
          />

          <div style={{ marginBottom: "15px" }}>
          <InputGroup
            inputs={[ 
              <>
                <InputGroup
                  label="Company"
                  inputs={[
                    <>
                      <input
                        type="text"
                        value={company?.company_name}
                        placeholder="Company"
                        disabled
                      />
                    </>,
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Functional Currency"
                  inputs={[
                    <input
                      type="text"
                      value={functionalCurrency}
                      placeholder="Functional Currency"
                      disabled
                    />,
                  ]}
                />
              </>,
            ]}
          />
        </div>

          <InputGroup
            inputs={[
              <>
                <InputGroup
                  label="Current Financial Year"
                  inputs={[
                    <div className="input-with-icon">
                    <input
                      type="text"
                      value={currentFinancialYear}
                      placeholder="Current Financial Year"
                      disabled
                    />
                    <span className="calendar-icon"><CalendarIcon/></span>
                  </div>,
                    
                  ]}
                />
              </>,
              <>
                <InputGroup
                  label="Previous Financial Year"
                  inputs={[
                    <div className="input-with-icon">
                    <input
                      type="text"
                      value={previousFinancialYear}
                      placeholder="Previous Financial Year"
                      disabled
                    />
                    <span className="calendar-icon"><CalendarIcon/></span>
                    </div>,
                  ]}
                />
              </>,
            ]}
          />
          <hr />
          <div>
            <div className={commoncss.dFlexJustifysb}>
              <span>
                Translation information :{" "}
                {functionalCurrency && (
                  <span className={commoncss.label8}>
                    {functionalCurrency ? functionalCurrency : "_"} to{" "}
                    {reportingCurrency?.value ? reportingCurrency?.value : "_"}
                  </span>
                )}
              </span>
              {/* <span>
                <Button btnColor={buttoncss.secondary} label="Fetch Rate" />
              </span> */}
            </div>
            <div className={standaloneCss.translateCard}>
              <div className={standaloneCss.translateCardHeader}>
                <span>Fill the details</span>
                {/* <Button
                  class_={standaloneCss.translateCardHeaderBtn}
                  btnColor={buttoncss.secondary}
                  label="Confirm"
                /> */}
              </div>
              <table className={standaloneCss.translateTable}>
                <thead>
                  <tr>
                    <th>DATE</th>
                    <th>OPENING RATE</th>
                    <th>CLOSING RATE</th>
                    <th>AVERAGE RATE</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <span>{currentFinancialYear}</span>
                    </td>
                    <td>
                      {currentFinancialYear && (
                        <InputGroup
                          width="116px"
                          input_width="116px"
                          inputs={[
                            <input
                              type="text"
                              placeholder="CY Opening Rate"
                              value={cyOpeningRate}
                              onChange={(e) => {
                                setCYOpeningRate(e.target.value);
                              }}
                            />,
                          ]}
                        />
                      )}
                    </td>

                    <td>
                      {currentFinancialYear && (
                        <InputGroup
                          width="116px"
                          input_width="116px"
                          inputs={[
                            <input
                              type="text"
                              placeholder="CY Closing Rate"
                              value={cyClosingRate}
                              onChange={(e) => {
                                setCYClosingRate(e.target.value);
                              }}
                            />,
                          ]}
                        />
                      )}
                    </td>

                    <td>
                      {currentFinancialYear && (
                        <InputGroup
                          width="116px"
                          input_width="116px"
                          inputs={[
                            <input
                              type="text"
                              placeholder="CY Average Rate"
                              value={cyAverageRate}
                              onChange={(e) => {
                                setCYAverageRate(e.target.value);
                              }}
                            />,
                          ]}
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <span>{previousFinancialYear}</span>
                    </td>
                    <td>
                      {previousFinancialYear && (
                        <InputGroup
                          width="116px"
                          input_width="116px"
                          inputs={[
                            <input
                              type="text"
                              placeholder="PY Opening Rate"
                              value={pyOpeningRate}
                              onChange={(e) => {
                                setPYOpeningRate(e.target.value);
                              }}
                            />,
                          ]}
                        />
                      )}
                    </td>

                    <td>
                      {previousFinancialYear && (
                        <InputGroup
                          width="116px"
                          input_width="116px"
                          inputs={[
                            <input
                              type="text"
                              placeholder="PY Closing Rate"
                              value={pyClosingRate}
                              onChange={(e) => {
                                setPYClosingRate(e.target.value);
                              }}
                            />,
                          ]}
                        />
                      )}
                    </td>

                    <td>
                      {previousFinancialYear && (
                        <InputGroup
                          width="116px"
                          input_width="116px"
                          inputs={[
                            <input
                              type="text"
                              placeholder="PY Average Rate"
                              value={pyAverageRate}
                              onChange={(e) => {
                                setPYAverageRate(e.target.value);
                              }}
                            />,
                          ]}
                        />
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TranslateFSModal;
